import { render, staticRenderFns } from "./ReCaptchaV3.vue?vue&type=template&id=4e108f81&scoped=true"
import script from "./ReCaptchaV3.vue?vue&type=script&lang=js"
export * from "./ReCaptchaV3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_0d1d51ab4c56f75a7402f3cb98fb63e0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e108f81",
  null
  
)

export default component.exports